import { WritableSignal } from '@angular/core';

const TUI_DARK_STORAGE_KEY = 'tuiDark';
const LEGACY_DARK_STORAGE_KEY = 'theme';

export function getStoredDarkTheme(): boolean {
  const tuiValue = window.localStorage.getItem(TUI_DARK_STORAGE_KEY);

  if (tuiValue !== null) {
    return tuiValue === 'true';
  }

  return !!window.localStorage.getItem(LEGACY_DARK_STORAGE_KEY);
}

export function setStoredDarkTheme(value: boolean): void {
  if (value) {
    window.localStorage.setItem(LEGACY_DARK_STORAGE_KEY, 'dark');
  } else {
    window.localStorage.removeItem(LEGACY_DARK_STORAGE_KEY);
  }
}

export function syncLegacyDarkTheme(darkMode: WritableSignal<boolean> & { reset(): void }): void {
  const tuiValue = window.localStorage.getItem(TUI_DARK_STORAGE_KEY);
  const legacyValue = window.localStorage.getItem(LEGACY_DARK_STORAGE_KEY);

  if (tuiValue === null && legacyValue !== null) {
    darkMode.set(true);
  }

  setStoredDarkTheme(darkMode());
}
